import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const Div = styled.div`
  font-family: "Airbnb Cereal App", sans-serif;

  .arrow {
    font-weight: 500;
    font-size: 0.875rem;
  }
`;

function Auth() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as any;
  const loggedInUser = useSelector(
    (state: RootState) => state.loggedInUser.data
  );
  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );

  useEffect(() => {
    if (loggedInUser && loggedInRole) {
      navigate(state?.uri ?? `/app/${loggedInRole.toLowerCase()}/home`, {
        replace: true,
      });
    }
  }, [loggedInUser, navigate, state?.uri, loggedInRole]);

  return (
    <Div className="p-4 mx-auto max-w-[500px]">
      <div>
        <button
          onClick={() => {
            navigate(-1);
          }}
          className="arrow flex items-center rounded-full mb-4 text-blue-500 py-2  outline-none ring-0 focus-visible:ring-1 ring-blue-500"
        >
          <BsArrowLeft className="mr-2" /> Go Back
        </button>
      </div>
      <Outlet />
    </Div>
  );
}

export default Auth;
